import {inject, Injectable} from '@angular/core';
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

@Injectable({
  providedIn: 'root'
})
export class BrowserDetectionService {
  //Injectables
  private _console = inject(Tools_aiConsoleService);
  isEdge(): boolean {
    const ua = window.navigator.userAgent;
    return ua.includes('Edg/') || ua.includes('Edge/');
  }

  async isEdgeModern(): Promise<boolean> {
    if ('userAgentData' in navigator) {
      const uaData = await (navigator as any).userAgentData.getHighEntropyValues(['brands']);
      return uaData.brands.some((b: any) => b.brand === 'Microsoft Edge');
    }
    return this.isEdge();
  }
}
